import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const PhoneIcon = props => {
  return (
    <Svg
      width={19}
      height={18}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.84 6.856a17.216 17.216 0 008.922 8.663l.012.005.764.34a2.25 2.25 0 002.74-.737l1.274-1.764a.25.25 0 00-.046-.34l-2.225-1.796a.25.25 0 00-.357.046l-.866 1.169a.75.75 0 01-.912.236 13.388 13.388 0 01-6.67-6.67.75.75 0 01.237-.911L6.88 4.23a.25.25 0 00.046-.358L5.132 1.648a.25.25 0 00-.341-.046l-1.773 1.28a2.25 2.25 0 00-.732 2.756l.554 1.217v.001zm8.33 10.041a18.716 18.716 0 01-9.694-9.416v-.003L.92 6.258A3.75 3.75 0 012.14 1.667L3.913.386a1.75 1.75 0 012.386.32l1.795 2.225a1.75 1.75 0 01-.32 2.505l-.67.496a11.892 11.892 0 005.118 5.118l.497-.67a1.75 1.75 0 012.504-.32l2.225 1.795a1.75 1.75 0 01.32 2.387l-1.275 1.764a3.75 3.75 0 01-4.565 1.229l-.758-.338z"
        fill="#001533"
      />
    </Svg>
  );
};

export default PhoneIcon;
